import styled from "styled-components";

export const CssHome = styled.div`
	width: 100%;
	background: #e90000;
	font-family: "Barlow", sans-serif;
	overflow: hidden;

	.caseHero {
		width: 100%;
		min-height: 450px;
		background: #e90000;
		position: relative;
		margin-top: 75px;
		overflow: hidden;
	}

	.caseContainer {
		width: 100%;
		max-width: 1440px;
		min-height: 450px;
		margin: 0 auto;
		position: relative;
		padding: 28px 4% 68px;
		box-sizing: border-box;
	}
	

	.jogaJuntoHeroContent {
		width: 100%;
		min-height: 335px;
		position: relative;
		z-index: 2;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		text-align: center;
		box-sizing: border-box;
		padding-top: 35px;
	}

	.jogaJuntoTitulo {
		width: 100%;
		position: relative;
		z-index: 3;
		margin-bottom: 58px;
	}

	.jogaJuntoTitulo h1 {
		margin: 0;
		color: #77e7ff;
		font-size: 38px;
		line-height: 0.95;
		font-weight: 800;
		letter-spacing: -0.05em;
	}

	.jogaJuntoTitulo h2 {
		margin: 2px 0 0;
		color: #77e7ff;
		font-size: 38px;
		line-height: 1;
		font-weight: 400;
		letter-spacing: -0.05em;
	}

	.jogaJuntoTexto {
		width: 100%;
		max-width: 860px;
		position: relative;
		z-index: 3;
		color: #fff7df;
		font-size: 20px;
		line-height: 1.45;
		font-weight: 400;
		letter-spacing: -0.03em;
		text-align: center;
	}

	.jogaJuntoTexto p {
		margin: 0;
	}

	.jogaJuntoTexto strong {
		font-weight: 800;
		color: #fff7df;
	}

	/* ========================= ANIMAÇÕES ========================= */

	.animJogaTitulo {
		opacity: 0;
		transform: translateY(-90px);
		transition: opacity 0.85s ease, transform 0.85s ease;
	}

	.animJogaTexto {
		opacity: 0;
		transform: translateY(35px);
		transition: opacity 0.85s ease 0.35s, transform 0.85s ease 0.35s;
	}

	.animateParte1 .animJogaTitulo,
	.animateParte1 .animJogaTexto {
		opacity: 1;
		transform: translateY(0);
	}

	/* ========================= RESPONSIVO ========================= */

	@media (max-width: 1366px) {
		.caseContainer {
			max-width: 1080px;
			padding: 28px 0 62px;
		}

		.jogaJuntoTitulo h1,
		.jogaJuntoTitulo h2 {
			font-size: 36px;
		}

		.jogaJuntoTexto {
			max-width: 820px;
			font-size: 19px;
		}
	}

	@media (max-width: 1100px) {
		.caseContainer {
			width: calc(100% - 80px);
		}

		.jogaJuntoTexto {
			max-width: 760px;
			font-size: 18px;
		}
	}

	@media (max-width: 768px) {
		.caseHero {
			min-height: 470px;
			margin-top: 70px;
		}

		.caseContainer {
			width: calc(100% - 52px);
			min-height: 470px;
			padding: 28px 0 56px;
		}

		.caseNav {
			font-size: 18px;
		}

		.jogaJuntoHeroContent {
			min-height: 345px;
			padding-top: 30px;
		}

		.jogaJuntoTitulo {
			margin-bottom: 44px;
		}

		.jogaJuntoTitulo h1,
		.jogaJuntoTitulo h2 {
			font-size: 32px;
		}

		.jogaJuntoTexto {
			max-width: 100%;
			font-size: 17px;
			line-height: 1.4;
		}

		.animJogaTitulo {
			transform: translateY(-65px);
		}

		.animJogaTexto {
			transform: translateY(28px);
		}
	}

	@media (max-width: 520px) {
		.caseHero {
			min-height: 430px;
		}

		.caseContainer {
			width: calc(100% - 36px);
			min-height: 430px;
			padding: 24px 0 48px;
		}

		.caseNav {
			font-size: 16px;
		}

		.caseNav img {
			width: 13px;
		}

		.jogaJuntoHeroContent {
			min-height: 315px;
			padding-top: 24px;
		}

		.jogaJuntoTitulo {
			margin-bottom: 34px;
		}

		.jogaJuntoTitulo h1,
		.jogaJuntoTitulo h2 {
			font-size: 28px;
		}

		.jogaJuntoTexto {
			font-size: 15px;
			line-height: 1.38;
		}
	}

	@media (max-width: 390px) {
		.jogaJuntoTitulo h1,
		.jogaJuntoTitulo h2 {
			font-size: 25px;
		}

		.jogaJuntoTexto {
			font-size: 14px;
		}
	}
`;

export const CssGif = styled.div`
	width: 100%;
	background: #fff;
	font-family: "Barlow", sans-serif;
	overflow: hidden;

	/* ========================= PARTE 2 - GIF ========================= */

	.gifSection {
		width: 100%;
		background: #000;
		position: relative;
		overflow: hidden;
		padding: 0;
		margin: 0;
		box-sizing: border-box;
	}

	.gifWrap {
		width: 100%;
		position: relative;

		iframe{
			width: 100%;
			height: 1080px
		}
	}

	.gifImg {
		width: 100%;
		height: auto;
		display: block;
		position: relative;
		z-index: 2;
	}

	/* ========================= ANIMAÇÃO ========================= */

	.animGif {
		opacity: 0;
		transform: translateY(140px);
		transition: opacity 0.95s ease, transform 0.95s ease;
	}

	.animateGif .animGif {
		opacity: 1;
		transform: translateY(0);
	}

	
	/* ========================= RESPONSIVO ========================= */


	@media (max-width: 1680px) {
		.gifWrap {

			iframe{
				width: 100%;
				height: 940px
			}
		}
	}

	@media (max-width: 1440px) {
		.gifWrap {

			iframe{
				width: 100%;
				height: 800px
			}
		}
	}

	@media (max-width: 1366px) {
		.gifWrap {

			iframe{
				width: 100%;
				height: 750px
			}
		}
	}

	@media (max-width: 1366px) {
		.gifWrap {

			iframe{
				width: 100%;
				height: 580px
			}
		}
	}


	@media (max-width: 820px) {
		
		.gifWrap {

			iframe{
				width: 100%;
				height:460px
			}
		}
		.animGif {
			transform: translateY(90px);
		}
	}

	@media (max-width: 520px) {

		.gifWrap {

			iframe{
				width: 100%;
				height:280px
			}
		}
		
	}

	@media (max-width: 420px) {

		.gifWrap {

			iframe{
				width: 100%;
				height:260px
			}
		}
		
	}

`;

export const CssPintouParceria = styled.div`
	width: 100%;
	background: #77e7ff;
	font-family: "Barlow", sans-serif;
	overflow: hidden;

	.pintouSection {
		width: 100%;
		background: #77e7ff;
		position: relative;
		overflow: hidden;
		padding: 0;
		box-sizing: border-box;
	}

	.pintouContainer {
		width: 100%;
		max-width: 1440px;
		height: 920px;
		margin: 0 auto;
		position: relative;
		overflow: hidden;
		box-sizing: border-box;
	}

	/* ========================= TEXTO ========================= */

	.pintouTextoArea {
		width: 100%;
		max-width: 390px;
		position: absolute;
		left: 9%;
		top: 220px;
		z-index: 30;
	}

	.pintouTitulo {
		margin: 0 0 28px;
		color: #e90000;
		font-size: 58px;
		line-height: 0.82;
		font-weight: 900;
		letter-spacing: -0.015em;
	}

	.pintouTitulo span {
		display: inline-block;
		margin-top: 12px;
		font-size: 31px;
		line-height: 1;
		font-weight: 800;
		letter-spacing: -0.05em;
	}

	.pintouTexto {
		width: 100%;
		max-width: 335px;
		color: #111;
		font-size: 20px;
		line-height: 1.28;
		font-weight: 400;
		letter-spacing: -0.035em;
	}

	.pintouTexto p {
		margin: 0;
	}

	/* ========================= ÁREA DOS CARDS ========================= */

	.pintouCardsArea {
		width: 710px;
		height: 650px;
		position: absolute;
		right: 6%;
		top: 35px;
		z-index: 10;
	}

	.pintouLogo {
		width: 160px;
		height: auto;
		display: block;
		position: absolute;
		left: 110px;
		top: 51px;
		z-index: 20;
	}

	.pintouCard {
		display: block;
		position: absolute;
		height: auto;
		z-index: 10;
		filter: drop-shadow(0 12px 14px rgba(0, 0, 0, 0.13));
	}

	.pintouCard1 {
		width: 178px;
		left: 105px;
		top: 170px;
		z-index: 15;
	}

	.pintouCard2 {
		width: 185px;
		left: 305px;
		top: 55px;
		z-index: 14;
	}

	.pintouCard3 {
		width: 178px;
		left: 505px;
		top: 115px;
		z-index: 15;
	}

	.pintouCardFade {
		position: absolute;
		width: 178px;
		height: auto;
		z-index: 8;
		overflow: hidden;
		filter: drop-shadow(0 12px 14px rgba(0, 0, 0, 0.1));
	}

	.pintouCardFade::after {
		content: "";
		width: 100%;
		height: 58%;
		position: absolute;
		left: 0;
		bottom: 0;
		z-index: 2;
		pointer-events: none;
		background: linear-gradient(
			to bottom,
			rgba(119, 231, 255, 0) 0%,
			rgba(119, 231, 255, 0.58) 45%,
			rgba(119, 231, 255, 1) 100%
		);
	}

	.pintouCardFadeImg {
		width: 100%;
		height: auto;
		display: block;
		position: relative;
		z-index: 1;
	}

	.pintouCardFade1 {
		left: 105px;
		top: 545px;
	}

	.pintouCardFade2 {
		left: 305px;
		top: 450px;
	}

	.pintouCardFade3 {
		left: 505px;
		top: 490px;
	}

	/* ========================= DECORAÇÕES SEPARADAS ========================= */

	.pintouDecorArea {
		width: 100%;
		height: 100%;
		position: absolute;
		inset: 0;
		z-index: 40;
		pointer-events: none;
	}

	.pintouTriangulo {
		width: 130px;
		height: auto;
		display: block;
		position: absolute;
		right: -80px;
		top: 170px;
		z-index: 1;
		pointer-events: none;
		opacity: 0;
		transform: translateX(110px);
		transition: opacity 0.75s ease 2.05s, transform 0.75s ease 2.05s;
	}

	.pintouCoracao {
		width: 55px;
		height: auto;
		display: block;
		position: absolute;
		z-index: 44;
		pointer-events: none;
	}

	.pintouCoracaoLeft {
		left: 49.2%;
		top: 265px;
	}

	.pintouCoracaoRight {
		right: 5.3%;
		top: 174px;
	}

	.pintouSetaBola {
		width: 40px;
		height: auto;
		display: block;
		position: absolute;
		left: 50%;
		top: 335px;
		z-index: 45;
		pointer-events: none;
	}

	.pintouSetaPreta {
		width: 30px;
		height: auto;
		display: block;
		position: absolute;
		z-index: 43;
		pointer-events: none;
	}

	.pintouSetaPretaTop {
		left: 47.2%;
		top: 175px;
	}

	.pintouSetaPretaBottom {
		right: 1.8%;
		top: 372px;
		transform: rotate(180deg);
	}

	/* ========================= ANIMAÇÕES ========================= */

	.animPintouTitulo {
		opacity: 0;
		transform: translateX(-140px);
		transition: opacity 0.85s ease, transform 0.85s ease;
	}

	.animPintouTexto {
		opacity: 0;
		transform: translateY(95px);
		transition: opacity 0.85s ease 0.25s, transform 0.85s ease 0.25s;
	}

	.animPintouLogo {
		opacity: 0;
		transform: translateY(-120px);
		transition: opacity 0.85s ease 0.45s, transform 0.85s ease 0.45s;
	}

	.animPintouCard {
		opacity: 0;
		transform: translateX(-120px);
		transition-property: opacity, transform;
		transition-duration: 0.75s;
		transition-timing-function: ease;
	}

	.pintouCard1 {
		transition-delay: 0.85s;
	}

	.pintouCard2 {
		transition-delay: 1.05s;
	}

	.pintouCard3 {
		transition-delay: 1.25s;
	}

	.pintouCardFade1 {
		transition-delay: 1.45s;
	}

	.pintouCardFade2 {
		transition-delay: 1.65s;
	}

	.pintouCardFade3 {
		transition-delay: 1.85s;
	}

	.animPintouCoracaoLeft {
		opacity: 0;
		transform: translateX(-110px) scale(0.9);
		transition: opacity 0.75s ease 2.2s, transform 0.75s ease 2.2s;
	}

	.animPintouCoracaoRight {
		opacity: 0;
		transform: translateX(110px) scale(0.9);
		transition: opacity 0.75s ease 2.35s, transform 0.75s ease 2.35s;
	}

	.animPintouSetaBola {
		opacity: 0;
		transform: translateY(70px);
		transition: opacity 0.7s ease 2.65s, transform 0.7s ease 2.65s;
	}

	.animPintouSetaPretaRight {
		opacity: 0;
		transform: translateX(95px);
		transition: opacity 0.7s ease 2.9s, transform 0.7s ease 2.9s;
	}

	.animPintouSetaPretaLeft {
		opacity: 0;
		transform: translateX(-95px) rotate(180deg);
		transition: opacity 0.7s ease 3.1s, transform 0.7s ease 3.1s;
	}

	.animatePintou .animPintouTitulo,
	.animatePintou .animPintouTexto,
	.animatePintou .animPintouLogo,
	.animatePintou .animPintouCard,
	.animatePintou .animPintouCoracaoLeft,
	.animatePintou .animPintouCoracaoRight,
	.animatePintou .animPintouSetaBola,
	.animatePintou .animPintouSetaPretaRight {
		opacity: 1;
		transform: translate(0, 0);
	}

	.animatePintou .pintouTriangulo {
		opacity: 1;
		transform: translateX(0);
	}

	.animatePintou .animPintouSetaPretaLeft {
		opacity: 1;
		transform: translateX(0) rotate(180deg);
	}

	/* ========================= RESPONSIVO ========================= */

	@media (max-width: 1366px) {
		.pintouContainer {
			height: 820px;
		}

		/* ========================= TEXTO ========================= */

		.pintouTextoArea {
			left: 8%;
			top: 195px;
		}

		.pintouTitulo {
			font-size: 50px;
		}

		.pintouTitulo span {
			font-size: 28px;
		}

		.pintouTexto {
			max-width: 300px;
			font-size: 19px;
		}

		/* ========================= ÁREA DOS CARDS ========================= */

		.pintouCardsArea {
			width: 690px;
			height: 610px;
			right: 3%;
			top: 34px;
		}

		.pintouLogo {
			width: 115px;
			left: 85px;
		}

		.pintouCard1,
		.pintouCardFade1 {
			width: 160px;
			left: 90px;
		}

		.pintouCard2,
		.pintouCardFade2 {
			width: 166px;
			left: 270px;
		}

		.pintouCard3,
		.pintouCardFade3 {
			width: 160px;
			left: 450px;
		}

		.pintouCard1 {
			top: 145px;
		}

		.pintouCard2 {
			top: 62px;
		}

		.pintouCard3 {
			top: 108px;
		}

		.pintouCardFade1 {
			top: 475px;
		}

		.pintouCardFade2 {
			top: 405px;
		}

		.pintouCardFade3 {
			top: 440px;
		}

		/* ========================= DECORAÇÕES SEPARADAS ========================= */

		.pintouTriangulo {
			width: 120px;
			top: 148px;
		}

		.pintouCoracaoRight {
			right: 4%;
			top: 155px;
		}
	}

	@media (max-width: 1100px) {
		.pintouContainer {
			height: 780px;
		}

		/* ========================= TEXTO ========================= */

		.pintouTextoArea {
			left: 5%;
			top: 178px;
			max-width: 315px;
		}

		.pintouTitulo {
			font-size: 44px;
		}

		.pintouTitulo span {
			font-size: 24px;
		}

		.pintouTexto {
			max-width: 275px;
			font-size: 17px;
		}

		/* ========================= ÁREA DOS CARDS ========================= */

		.pintouCardsArea {
			width: 555px;
			height: 560px;
			right: 2%;
			top: 45px;
		}

		.pintouCard1,
		.pintouCardFade1 {
			width: 138px;
			left: 70px;
		}

		.pintouCard2,
		.pintouCardFade2 {
			width: 144px;
			left: 220px;
		}

		.pintouCard3,
		.pintouCardFade3 {
			width: 138px;
			left: 370px;
		}

		.pintouCard1 {
			top: 145px;
		}

		.pintouCard2 {
			top: 80px;
		}

		.pintouCard3 {
			top: 122px;
		}

		.pintouCardFade1 {
			top: 430px;
		}

		.pintouCardFade2 {
			top: 380px;
		}

		.pintouCardFade3 {
			top: 410px;
		}

		/* ========================= DECORAÇÕES SEPARADAS ========================= */

		.pintouCoracao {
			width: 50px;
		}

		.pintouCoracaoLeft {
			left: 45%;
			top: 214px;
		}

		.pintouCoracaoRight {
			right: 3%;
			top: 160px;
		}

		.pintouSetaBola {
			left: 48.6%;
			top: 280px;
		}

		.pintouSetaPreta {
			width: 58px;
		}

		.pintouSetaPretaTop {
			left: 44%;
			top: 166px;
			width: 30px;
		}

		.pintouSetaPretaBottom {
			right: 1%;
			top: 355px;
			width: 30px;
		}
	}

	@media (max-width: 820px) {
		.pintouContainer {
			height: 780px;
		}

		/* ========================= TEXTO ========================= */

		.pintouTextoArea {
			left: 30px;
			top: 70px;
			max-width: 340px;
		}

		.pintouTitulo {
			font-size: 42px;
		}

		.pintouTitulo span {
			font-size: 23px;
		}

		.pintouTexto {
			max-width: 300px;
			font-size: 16px;
		}

		/* ========================= ÁREA DOS CARDS ========================= */

		.pintouCardsArea {
			width: 100%;
			height: 520px;
			right: auto;
			left: 0;
			top: 210px;
		}

		.pintouLogo {
			width: 150px;
			left: 72%;
			top: -176px;
		}

		.pintouCard1,
		.pintouCardFade1 {
			width: 130px;
			left: 18%;
		}

		.pintouCard2,
		.pintouCardFade2 {
			width: 136px;
			left: 41%;
		}

		.pintouCard3,
		.pintouCardFade3 {
			width: 130px;
			left: 64%;
		}

		.pintouCard1 {
			top: 115px;
		}

		.pintouCard2 {
			top: 35px;
		}

		.pintouCard3 {
			top: 88px;
		}

		.pintouCardFade1 {
			top: 340px;
		}

		.pintouCardFade2 {
			top: 288px;
		}

		.pintouCardFade3 {
			top: 296px;
		}

		/* ========================= DECORAÇÕES SEPARADAS ========================= */

		.pintouCoracao {
			width: 58px;
		}

		.pintouCoracaoLeft {
			left: 12%;
			top: 362px;
		}

		.pintouCoracaoRight {
			right: 8%;
			top: 276px;
		}

		.pintouSetaBola {
			width: 44px;
			left: 14%;
			top: 428px;
		}

		.pintouSetaPreta {
			width: 52px;
		}

		.pintouSetaPretaTop {
			left: 5%;
			top: 198px;
		}

		.pintouSetaPretaBottom {
			right: 4%;
			top: 420px;
		}

		.pintouTriangulo {
			width: 115px;
			right: -42px;
			top: 235px;
		}

		/* ========================= ANIMAÇÕES MOBILE ========================= */

		.animPintouTitulo {
			transform: translateX(-90px);
		}

		.animPintouTexto {
			transform: translateY(70px);
		}

		.animPintouLogo {
			transform: translateY(-90px);
		}

		.animPintouCard {
			transform: translateX(-80px);
		}
	}

	@media (max-width: 520px) {
		.pintouContainer {
			height: 830px;
		}

		/* ========================= TEXTO ========================= */

		.pintouTextoArea {
			left: 22px;
			top: 54px;
			max-width: 270px;
		}

		.pintouTitulo {
			font-size: 35px;
		}

		.pintouTitulo span {
			font-size: 19px;
		}

		.pintouTexto {
			max-width: 245px;
			font-size: 14px;
		}

		/* ========================= ÁREA DOS CARDS ========================= */

		.pintouCardsArea {
			top: 225px;
		}

		.pintouLogo {
			left: 60%;
		}

		.pintouCard1,
		.pintouCardFade1 {
			width: 105px;
			left: 12%;
		}

		.pintouCard2,
		.pintouCardFade2 {
			width: 110px;
			left: 38%;
		}

		.pintouCard3,
		.pintouCardFade3 {
			width: 105px;
			left: 64%;
		}

		.pintouCard1 {
			top: 120px;
		}

		.pintouCard2 {
			top: 65px;
		}

		.pintouCard3 {
			top: 118px;
		}

		.pintouCardFade1 {
			top: 340px;
		}

		.pintouCardFade2 {
			top: 290px;
		}

		.pintouCardFade3 {
			top: 340px;
		}

		/* ========================= DECORAÇÕES SEPARADAS ========================= */

		.pintouCoracao {
			width: 48px;
		}

		.pintouCoracaoLeft {
			left: 7%;
			top: 360px;
		}

		.pintouCoracaoRight {
			right: 4%;
			top: 360px;
		}

		.pintouSetaBola {
			width: 36px;
			left: 9%;
			top: 424px;
		}

		.pintouSetaPreta {
			width: 25px;
		}

		.pintouSetaPretaTop {
			top: 290px;
		}

		.pintouSetaPretaBottom {
			right: 2%;
			top: 480px;
		}

		.pintouTriangulo {
			width: 95px;
			right: -38px;
			top: 240px;
			display: none;
		}
	}

	@media (max-width: 390px) {
		.pintouContainer {
			height: 750px;
		}

		/* ========================= TEXTO ========================= */

		.pintouTextoArea {
			left: 18px;
			max-width: 245px;
		}

		.pintouTitulo {
			font-size: 31px;
		}

		.pintouTitulo span {
			font-size: 17px;
		}

		.pintouTexto {
			max-width: 220px;
			font-size: 13px;
		}

		/* ========================= ÁREA DOS CARDS ========================= */

		.pintouLogo {
			width: 105px;
		}

		.pintouCard1,
		.pintouCardFade1 {
			width: 92px;
		}

		.pintouCard2,
		.pintouCardFade2 {
			width: 96px;
		}

		.pintouCard3,
		.pintouCardFade3 {
			width: 92px;
		}

		.pintouCard1 {
			top: 115px;
		}

		.pintouCard2 {
			top: 70px;
		}

		.pintouCard3 {
			top: 118px;
		}

		.pintouCardFade1 {
			top: 278px;
		}

		.pintouCardFade2 {
			top: 250px;
		}

		.pintouCardFade3 {
			top: 254px;
		}

		/* ========================= DECORAÇÕES SEPARADAS ========================= */
		/* Mantém as posições herdadas do max-width: 520px */
	}
`;

export const CssViagem = styled.div`
	width: 100%;
	background: #fff7df;
	font-family: "Barlow", sans-serif;
	overflow: hidden;

	.viagemSection {
		width: 100%;
		position: relative;
		overflow: hidden;
		background-size: cover;
		background-position: center center;
		background-repeat: no-repeat;
		padding: 0;
		box-sizing: border-box;
	}

	.viagemSection::before {
		content: "";
		width: 100%;
		height: 100%;
		position: absolute;
		inset: 0;
		z-index: 1;
		background: rgba(255, 247, 223, 0.04);
		pointer-events: none;
	}

	.viagemContainer {
		width: 100%;
		max-width: 1440px;
		height: 1070px;
		margin: 0 auto;
		position: relative;
		z-index: 2;
		overflow: hidden;
		box-sizing: border-box;
	}

	/* ========================= FOTOS ========================= */

	.viagemFotosArea {
		width: 100%;
		height: 100%;
		position: absolute;
		inset: 0;
		z-index: 4;
	}

	.viagemFoto {
		display: block;
		position: absolute;
		object-fit: cover;
		z-index: 5;
		box-sizing: border-box;
		filter: drop-shadow(0 14px 18px rgba(0, 0, 0, 0.16));
	}

	.viagemFoto1 {
		width: 330px;
		height: 380px;
		left: -105px;
		top: 255px;
		z-index: 7;
	}

	.viagemFoto2 {
		width: 585px;
		height: 395px;
		left: 250px;
		top: 72px;
		z-index: 8;
	}

	.viagemFoto3 {
		width: 450px;
		height: 320px;
		right: 40px;
		top: 66px;
		z-index: 7;
	}

	.viagemFoto4 {
		width: 480px;
		left: 250px;
		top: 480px;
		z-index: 6;
	}

	.viagemFoto5 {
		width: 520px;
		height: 345px;
		right: 22px;
		top: 410px;
		z-index: 6;
	}

	/* ========================= TEXTO ========================= */

	.viagemTexto {
		width: 100%;
		max-width: 360px;
		position: absolute;
		left: 145px;
		bottom: 88px;
		z-index: 10;
		color: #fff7df;
		font-size: 22px;
		line-height: 1.25;
		font-weight: 400;
		letter-spacing: -0.035em;
		text-align: left;
	}

	.viagemTexto p {
		margin: 0;
	}

	/* ========================= ANIMAÇÕES ========================= */

	.animViagemFoto {
		opacity: 0;
		transform: translateX(-150px);
		transition-property: opacity, transform;
		transition-duration: 0.78s;
		transition-timing-function: ease;
	}

	.viagemFoto1 {
		transition-delay: 0.15s;
	}

	.viagemFoto2 {
		transition-delay: 0.35s;
	}

	.viagemFoto3 {
		transition-delay: 0.55s;
	}

	.viagemFoto4 {
		transition-delay: 0.75s;
	}

	.viagemFoto5 {
		transition-delay: 0.95s;
	}

	.animViagemTexto {
		opacity: 0;
		transform: translateY(85px);
		transition: opacity 0.85s ease 1.35s, transform 0.85s ease 1.35s;
	}

	.animateViagem .animViagemFoto {
		opacity: 1;
		transform: translateX(0);
	}

	.animateViagem .animViagemTexto {
		opacity: 1;
		transform: translateY(0);
	}

	/* ========================= RESPONSIVO ========================= */

	@media (max-width: 1366px) {
		.viagemContainer {			
			height: 920px;
		}

		.viagemFoto1 {
			width: 280px;
			height: 335px;
			top: 230px;
		}

		.viagemFoto2 {
			width: 480px;
			height: 330px;
			left: 220px;
			top: 68px;
		}

		.viagemFoto3 {
			width: 380px;
			height: 280px;
			top: 62px;
		}

		.viagemFoto4 {
			width: 430px;
			height: 235px;
			left: 220px;
			top: 420px;
		}

		.viagemFoto5 {
			width: 430px;
			height: 295px;
			right: 22px;
			top: 365px;
		}

		.viagemTexto {
			max-width: 330px;
			left: 115px;
			bottom: 80px;
			font-size: 20px;
		}
	}

	@media (max-width: 1100px) {		

		.viagemFoto1 {
			width: 230px;
			height: 300px;			
			top: 245px;
			 left: -75px;
		}

		.viagemFoto2 {
			width: 410px;
			height: 300px;
			left: 190px;
			top: 70px;
		}

		.viagemFoto3 {
			width: 340px;
			height: 250px;
			right: 35px;
			top: 75px;
		}

		.viagemFoto4 {
			width: 380px;
			height: 215px;
			left: 190px;
			top: 390px;
		}

		.viagemFoto5 {
			width: 390px;
			height: 275px;
			right: 18px;
			top: 372px;
		}

		.viagemTexto {
			max-width: 310px;
			left: 85px;
			bottom: 70px;
			font-size: 19px;
		}
	}

	@media (max-width: 820px) {
		.viagemSection {
			background-position: center center;
		}

		.viagemContainer {
			height: 785px;
		}

		.viagemFoto1 {
			width: 210px;
			height: 280px;
			left: -18px;
			top: 285px;
		}

		.viagemFoto2 {
			width:320px;
        	height: 205px;
			left: 160px;
			top: 70px;
		}

		.viagemFoto3 {
			width: 240px;
        	height: 185px;
			right: 18px;
			top: 70px;
		}

		.viagemFoto4 {
			width: 250px;
			height: 160px;
			left: 225px;
			top: 315px;
		}

		.viagemFoto5 {
			width: 240px;
			height: 174px;
			right: 55px;
			top: 285px;
		}

		.viagemTexto {
			max-width: 300px;
			left: 44px;
			bottom: 64px;
			font-size: 18px;
			z-index: 15;
		}

		.animViagemFoto {
			transform: translateX(-95px);
		}

		.animViagemTexto {
			transform: translateY(60px);
		}
	}

	@media (max-width: 520px) {
		.viagemContainer {
			height: 955px;
		}

		.viagemFoto1 {
			width: 165px;
			height: 235px;
			left: -40px;
			top: 250px;
		}

		.viagemFoto2 {
			width: 315px;
			height: 230px;
			left: 80px;
			top: 58px;
		}

		.viagemFoto3 {
			width: 245px;
			height: 190px;
			right: -32px;
			top: 305px;
		}

		.viagemFoto4 {
			width: 300px;
			height: 180px;
			left: 55px;
			top: 470px;
		}

		.viagemFoto5 {
			width: 285px;
			height: 205px;
			right: -20px;
			top: 615px;
		}

		.viagemTexto {
			max-width: 340px;
			left: 22px;
			bottom: 50px;
			font-size: 15px;
		}
	}

	@media (max-width: 390px) {		

		.viagemFoto1 {
			width: 145px;
			height: 215px;
			left: -42px;
			top: 240px;
		}

		.viagemFoto2 {
			width: 280px;
			height: 210px;
			left: 68px;
			top: 52px;
		}

		.viagemFoto3 {
			width: 220px;
			height: 175px;
			right: -36px;
			top: 288px;
		}

		.viagemFoto4 {
			width: 270px;
			height: 165px;
			left: 48px;
			top: 440px;
		}

		.viagemFoto5 {
			width: 255px;
			height: 190px;
			right: -22px;
			top: 575px;
		}

		.viagemTexto {
			max-width: 340px;
			left: 22px;
			bottom: 50px;
			font-size: 15px;
		}
	}
`;

export const CssNumeros = styled.div`
	width: 100%;
	background: #e90000;
	font-family: "Barlow", sans-serif;
	overflow: hidden;

	.numerosSection {
		width: 100%;
		background: #e90000;
		position: relative;
		overflow: hidden;
		padding: 4% 0;
		box-sizing: border-box;
		min-height: 600px;
	}

	.numerosContainer {
		width: 100%;
		max-width: 1440px;
		height: 610px;
		margin: 0 auto;
		position: relative;
		overflow: hidden;
		box-sizing: border-box;
	}

	/* ========================= ELEMENTOS ========================= */

	.numerosCelular {
		width: 750px;
		height: auto;
		display: block;
		position: absolute;
		left: 15%;
		top: 34px;
		z-index: 20;
	}

	.numerosTrianguloAzul {
		width: 108px;
		height: auto;
		display: block;
		position: absolute;
		left: 44px;
		top: 47px;
		z-index: 4;
		pointer-events: none;
	}

	.numerosSetaBege {
		width: 46px;
		height: auto;
		display: block;
		position: absolute;
		left: 203px;
		top: 94px;
		z-index: 8;
		pointer-events: none;
	}

	.numerosTrianguloCheioAzul {
		width: 72px;
		height: auto;
		display: block;
		position: absolute;
		right: 84px;
		top: 159px;
		z-index: 8;
		pointer-events: none;
	}

	.numerosZ {
		width: 205px;
		height: auto;
		display: block;
		position: absolute;
		right: 25%;
		bottom: 40px;
		z-index: 5;
		pointer-events: none;
	}

	.numerosTrianguloBege {
		width: 118px;
		height: auto;
		display: block;
		position: absolute;
		right: -72px;
		top: 318px;
		z-index: 9;
		pointer-events: none;
	}

	/* ========================= NÚMEROS ========================= */

	.numerosStat {
		position: absolute;
		z-index: 18;
		color: #fff7df;
		line-height: 1;
	}

	.numerosStat strong {
		display: block;
		color: #77e7ff;
		font-size: 145px;
		line-height: 0.82;
		font-weight: 900;
		letter-spacing: -0.015em;
	}

	.numerosStat span {
		display: block;
		margin-top: 8px;
		color: #fff7df;
		font-size: 18px;
		line-height: 1.15;
		font-weight: 400;
		letter-spacing: -0.035em;
	}

	.numerosStat span strong {
		display: inline;
		color: #fff7df;
		font-size: inherit;
		line-height: inherit;
		font-weight: 800;
		letter-spacing: inherit;
	}

	.numerosStat15 {
		left: 62px;
		top: 174px;
	}

	.numerosStat100 {
		right: 168px;
		top: 54px;
	}

	.numerosStat20 {
		left: 208px;
		top: 365px;
	}

	.numerosStat20 strong {
		font-size: 140px;
	}

	/* ========================= ANIMAÇÕES ========================= */

	.animNumerosTrianguloAzul {
		opacity: 0;
		transform: translateX(-120px);
		transition: opacity 0.8s ease, transform 0.8s ease;
	}

	.animNumerosSetaBege {
		opacity: 0;
		transform: translateY(-90px);
		transition: opacity 0.75s ease 0.25s, transform 0.75s ease 0.25s;
	}

	.animNumerosCelular {
		opacity: 0;
		transform: translateY(140px) scale(0.9);
		filter: blur(4px);
		transition:
			opacity 0.95s ease 0.65s,
			transform 0.95s ease 0.65s,
			filter 0.95s ease 0.65s;
	}

	.animNumeros15 {
		opacity: 0;
		transform: translateX(-130px);
		transition: opacity 0.85s ease 1.35s, transform 0.85s ease 1.35s;
	}

	.animNumeros100 {
		opacity: 0;
		transform: translateY(-110px);
		transition: opacity 0.85s ease 1.55s, transform 0.85s ease 1.55s;
	}

	.animNumeros20 {
		opacity: 0;
		transform: translateY(110px);
		transition: opacity 0.85s ease 1.75s, transform 0.85s ease 1.75s;
	}

	.animNumerosTrianguloCheioAzul {
		opacity: 0;
		transform: translateX(90px);
		transition: opacity 0.75s ease 0.95s, transform 0.75s ease 0.95s;
	}

	.animNumerosZ {
		opacity: 0;
		transform: translateY(95px);
		transition: opacity 0.85s ease 1.95s, transform 0.85s ease 1.95s;
	}

	.animNumerosTrianguloBege {
		opacity: 0;
		transform: translateX(110px);
		transition: opacity 0.75s ease 1.05s, transform 0.75s ease 1.05s;
	}

	.animateNumeros .animNumerosTrianguloAzul,
	.animateNumeros .animNumerosSetaBege,
	.animateNumeros .animNumeros15,
	.animateNumeros .animNumeros100,
	.animateNumeros .animNumeros20,
	.animateNumeros .animNumerosTrianguloCheioAzul,
	.animateNumeros .animNumerosZ,
	.animateNumeros .animNumerosTrianguloBege {
		opacity: 1;
		transform: translate(0, 0);
	}

	.animateNumeros .animNumerosCelular {
		opacity: 1;
		transform: translateY(0) scale(1);
		filter: blur(0);
	}

	/* ========================= RESPONSIVO ========================= */

	@media (max-width: 1366px) {
		.numerosSection {
			padding: 4% 0;
			min-height: 560px;
		}

		.numerosContainer {
			max-width: 1180px;
			height: 560px;
		}

		/* ========================= ELEMENTOS ========================= */

		.numerosCelular {
			width: 640px;
			left: 16%;
			top: 28px;
		}

		.numerosTrianguloAzul {
			width: 96px;
			left: 36px;
			top: 40px;
		}

		.numerosSetaBege {
			width: 40px;
			left: 180px;
			top: 82px;
		}

		.numerosTrianguloCheioAzul {
			width: 66px;
			right: 72px;
			top: 148px;
		}

		.numerosZ {
			width: 180px;
			right: 25%;
			bottom: 38px;
		}

		.numerosTrianguloBege {
			width: 105px;
			right: -66px;
			top: 300px;
		}

		/* ========================= NÚMEROS ========================= */

		.numerosStat strong {
			font-size: 124px;
		}

		.numerosStat20 strong {
			font-size: 122px;
		}

		.numerosStat span {
			font-size: 17px;
		}

		.numerosStat15 {
			left: 54px;
			top: 165px;
		}

		.numerosStat100 {
			right: 140px;
			top: 45px;
		}

		.numerosStat20 {
			left: 190px;
			top: 345px;
		}
	}

	@media (max-width: 1100px) {
		.numerosSection {
			padding: 5% 0;
			min-height: 535px;
		}

		.numerosContainer {
			max-width: 100%;
			height: 535px;
		}

		/* ========================= ELEMENTOS ========================= */

		.numerosCelular {
			width: 570px;
			left: 17%;
			top: 35px;
			min-width: 0;
		}

		.numerosTrianguloAzul {
			width: 84px;
			left: 30px;
			top: 36px;
		}

		.numerosSetaBege {
			width: 36px;
			left: 158px;
			top: 78px;
		}

		.numerosTrianguloCheioAzul {
			width: 58px;
			right: 60px;
			top: 150px;
		}

		.numerosZ {
			width: 165px;
			right: 21%;
			bottom: 40px;
		}

		.numerosTrianguloBege {
			width: 95px;
			right: -62px;
			top: 292px;
		}

		/* ========================= NÚMEROS ========================= */

		.numerosStat strong {
			font-size: 104px;
		}

		.numerosStat20 strong {
			font-size: 106px;
		}

		.numerosStat span {
			font-size: 16px;
		}

		.numerosStat15 {
			left: 48px;
			top: 165px;
		}

		.numerosStat100 {
			right: 100px;
			top: 48px;
		}

		.numerosStat20 {
			left: 165px;
			top: 340px;
		}
	}

	@media (max-width: 900px) {
		.numerosSection {
			padding: 6% 0;
			min-height: 650px;
		}

		.numerosContainer {
			height: 650px;
		}

		/* ========================= ELEMENTOS ========================= */

		.numerosCelular {
			width: 625px;
			left: 0%;
			top: 60px;
		}

		.numerosTrianguloAzul {
			width: 78px;
			left: 24px;
			top: 34px;
		}

		.numerosSetaBege {
			width: 34px;
			left: 135px;
			top: 78px;
		}

		.numerosTrianguloCheioAzul {
			width: 56px;
			right: 34px;
			top: 205px;
		}

		.numerosZ {
			width: 155px;
			right: 12%;
			bottom: 70px;
		}

		.numerosTrianguloBege {
			width: 92px;
			right: -62px;
			top: 355px;
		}

		/* ========================= NÚMEROS ========================= */

		.numerosStat strong {
			font-size: 82px;
		}

		.numerosStat20 strong {
			font-size: 88px;
		}

		.numerosStat span {
			font-size: 15px;
		}

		.numerosStat15 {
			left: 34px;
			top: 170px;
		}

		.numerosStat100 {
			right: 42px;
			top: 58px;
		}

		.numerosStat20 {
			left: 48px;
			top: auto;
			bottom: 92px;
		}

		/* ========================= ANIMAÇÕES MOBILE ========================= */

		.animNumerosTrianguloAzul {
			transform: translateX(-80px);
		}

		.animNumerosSetaBege {
			transform: translateY(-70px);
		}

		.animNumerosCelular {
			transform: translateY(100px) scale(0.9);
		}
	}

	@media (max-width: 768px) {
		.numerosSection {
			min-height: 675px;
		}

		.numerosContainer {
			height: 675px;
		}

		/* ========================= ELEMENTOS ========================= */

		.numerosCelular {
			width: 485px;
			left: 18%;
			top: 135px;
		}

		.numerosTrianguloAzul {
			width: 72px;
			left: 22px;
			top: 30px;
		}

		.numerosSetaBege {
			width: 30px;
			left: 30px;
			top: 120px;
		}

		.numerosTrianguloCheioAzul {
			width: 52px;
			right: 30px;
			top: 220px;
		}

		.numerosZ {
			width: 145px;
			right: 10%;
			bottom: 76px;
		}

		.numerosTrianguloBege {
			width: 84px;
			right: -58px;
			top: 370px;
		}

		/* ========================= NÚMEROS ========================= */

		.numerosStat strong {
			font-size: 74px;
		}

		.numerosStat20 strong {
			font-size: 80px;
		}

		.numerosStat span {
			font-size: 14px;
		}

		.numerosStat15 {
			left: 30px;
			top: 165px;
		}

		.numerosStat100 {
			right: 32px;
			top: 52px;
		}

		.numerosStat20 {
			left: 36px;
			bottom: 90px;
		}
	}

	@media (max-width: 520px) {
		.numerosSection {
			padding: 5% 0;
			min-height: 660px;
		}

		.numerosContainer {
			height: 600px;
		}

		/* ========================= ELEMENTOS ========================= */

		.numerosCelular {
			width: 475px;
			left: -23%;
			top: 105px;
		}

		.numerosTrianguloAzul {
			width: 64px;
			left: 18px;
			top: 28px;
		}

		.numerosSetaBege {
			width: 28px;
			left: 98px;
			top: 66px;
		}

		.numerosTrianguloCheioAzul {
			width: 46px;
			right: 22px;
			top: 225px;
			display: none
		}

		.numerosZ {
			width: 70px;
			right: 16px;
			bottom: 150px;
		}

		.numerosTrianguloBege {
			width: 72px;
			right: -48px;
			top: 390px;
		}

		/* ========================= NÚMEROS ========================= */

		.numerosStat strong {
			font-size: 56px;
		}

		.numerosStat20 strong {
			font-size: 64px;
		}

		.numerosStat span {
			font-size: 12px;
		}

		.numerosStat15 {
			left: 22px;
			top: 310px;
		}

		.numerosStat100 {
			right: 18px;
			top: 54px;
		}

		.numerosStat20 {
			left: 24px;
			bottom: 75px;
		}
	}

	@media (max-width: 390px) {
		.numerosSection {
			min-height: 650px;
		}

		.numerosContainer {
			height: 650px;
		}

		/* ========================= ELEMENTOS ========================= */
		
		.numerosTrianguloAzul {
			width: 56px;
			left: 16px;
			top: 26px;
		}

		.numerosSetaBege {
			width: 25px;
			left: 84px;
			top: 60px;
		}

		.numerosTrianguloCheioAzul {
			width: 40px;
			right: 16px;
			top: 215px;
		}

		.numerosZ {
			width: 112px;
			right: 8px;
			bottom: 95px;
		}

		.numerosTrianguloBege {
			width: 64px;
			right: -44px;
			top: 365px;
		}

		/* ========================= NÚMEROS ========================= */

		.numerosStat strong {
			font-size: 48px;
		}

		.numerosStat20 strong {
			font-size: 56px;
		}

		.numerosStat span {
			font-size: 11px;
		}

		
		.numerosStat100 {
			right: 12px;
			top: 52px;
		}

		.numerosStat20 {
			left: 20px;
			bottom:130px;
		}
	}
`;

export const CssEquipe = styled.div`
	width: 100%;
	background: #fff7df;
	font-family: "Barlow", sans-serif;
	overflow: hidden;

	.equipeSection {
		width: 100%;
		background: #fff7df;
		position: relative;
		overflow: hidden;
		padding: 44px 0 58px;
		box-sizing: border-box;
	}

	.equipeContainer {
		width: 100%;
		max-width: 1080px;
		height: 715px;
		margin: 0 auto;
		position: relative;
		overflow: visible;
		box-sizing: border-box;
	}

	/* ========================= TÍTULO ========================= */

	.equipeTitulo {
		width: 100%;
		margin: 0;
		position: relative;
		z-index: 8;
		color: #152020;
		font-size: 58px;
		line-height: 1;
		font-weight: 700;
		letter-spacing: -0.025em;
		text-align: center;
	}

	/* ========================= FOTOS ========================= */

	.equipeFotosArea {
		width: 100%;
		height: 600px;
		position: absolute;
		left: 0;
		top: 89px;
		z-index: 4;
	}

	.equipeFoto {
		display: block;
		position: absolute;
		height: auto;
		object-fit: contain;
		z-index: 5;
	}

	/* PRIMEIRA LINHA - DESALINHADA */
	.equipeFoto1 {
		width: 255px;
		left: -3px;
		top: 74px;
	}

	.equipeFoto2 {
		width: 222px;
		left: 268px;
		top: 44px;
	}

	.equipeFoto3 {
		width: 338px;
		left: 506px;
		top: 104px;
	}

	.equipeFoto4 {
		width: 222px;
		left: 858px;
		top: 44px;
	}

	/* SEGUNDA LINHA - COLADA NO BOTTOM VISUAL DA PRIMEIRA */
	.equipeFoto5 {
		width: 255px;
		left: -3px;
		top: 340px;
	}

	.equipeFoto6 {
		width: 222px;
		left: 268px;
		top: 340px;
	}

	.equipeFoto7 {
		width: 338px;
		left: 506px;
		top: 340px;
	}

	.equipeFoto8 {
		width: 222px;
		left: 858px;
		top: 340px;
	}

	/* ========================= ANIMAÇÕES ========================= */

	.animEquipeTitulo {
		opacity: 0;
		transform: translateY(-65px);
		transition: opacity 0.85s ease, transform 0.85s ease;
	}

	.animEquipeFoto {
		opacity: 0;
		transform: translateX(-120px);
		transition-property: opacity, transform;
		transition-duration: 0.75s;
		transition-timing-function: ease;
	}

	.equipeFoto1 {
		transition-delay: 0.35s;
	}

	.equipeFoto2 {
		transition-delay: 0.52s;
	}

	.equipeFoto3 {
		transition-delay: 0.69s;
	}

	.equipeFoto4 {
		transition-delay: 0.86s;
	}

	.equipeFoto5 {
		transition-delay: 1.03s;
	}

	.equipeFoto6 {
		transition-delay: 1.2s;
	}

	.equipeFoto7 {
		transition-delay: 1.37s;
	}

	.equipeFoto8 {
		transition-delay: 1.54s;
	}

	.animateEquipe .animEquipeTitulo,
	.animateEquipe .animEquipeFoto {
		opacity: 1;
		transform: translate(0, 0);
	}

	/* ========================= RESPONSIVO ========================= */

	@media (max-width: 1100px) {
		.equipeSection {
			padding: 40px 0 54px;
		}

		.equipeContainer {
			max-width: 900px;
			height: 610px;
		}

		.equipeTitulo {
			font-size: 48px;
		}

		.equipeFotosArea {
			top: 78px;
		}

		.equipeFoto1 {
			width: 212px;
			left: -3px;
			top: 62px;
		}

		.equipeFoto2 {
			width: 185px;
			left: 223px;
			top: 37px;
		}

		.equipeFoto3 {
			width: 282px;
			left: 422px;
			top: 87px;
		}

		.equipeFoto4 {
			width: 185px;
			left: 715px;
			top: 37px;
		}

		.equipeFoto5 {
			width: 212px;
			left: -3px;
			top: 284px;
		}

		.equipeFoto6 {
			width: 185px;
			left: 223px;
			top: 284px;
		}

		.equipeFoto7 {
			width: 282px;
			left: 422px;
			top: 284px;
		}

		.equipeFoto8 {
			width: 185px;
			left: 715px;
			top: 284px;
		}
	}

	@media (max-width: 920px) {
		.equipeSection {
			padding: 38px 0 50px;
		}

		.equipeContainer {
			max-width: 760px;
			height: 535px;
		}

		.equipeTitulo {
			font-size: 42px;
		}

		.equipeFotosArea {
			top: 72px;
		}

		.equipeFoto1 {
			width: 179px;
			left: -2px;
			top: 52px;
		}

		.equipeFoto2 {
			width: 156px;
			left: 188px;
			top: 31px;
		}

		.equipeFoto3 {
			width: 238px;
			left: 356px;
			top: 73px;
		}

		.equipeFoto4 {
			width: 156px;
			left: 604px;
			top: 31px;
		}

		.equipeFoto5 {
			width: 179px;
			left: -2px;
			top: 239px;
		}

		.equipeFoto6 {
			width: 156px;
			left: 188px;
			top: 239px;
		}

		.equipeFoto7 {
			width: 238px;
			left: 356px;
			top: 239px;
		}

		.equipeFoto8 {
			width: 156px;
			left: 604px;
			top: 239px;
		}

		.animEquipeTitulo {
			transform: translateY(-50px);
		}

		.animEquipeFoto {
			transform: translateX(-85px);
		}
	}

	@media (max-width: 768px) {
	.equipeSection {
		padding: 38px 0 48px;
	}

	.equipeContainer {
		width: calc(100% - 30px);
		max-width: 560px;
		height: auto;
		min-height: auto;
		overflow: visible;
	}

	.equipeTitulo {
		font-size: 36px;
		line-height: 0.95;
		margin-bottom: 34px;
	}

	.equipeFotosArea {
		width: 100%;
		height: auto;
		position: relative;
		left: auto;
		top: auto;
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		gap: 10px;
		align-items: start;
	}

	.equipeFoto {
		width: 100%;
		height: auto;
		position: relative;
		left: auto;
		right: auto;
		top: auto;
		display: block;
		object-fit: contain;
	}

	.equipeFoto1,
	.equipeFoto2,
	.equipeFoto3,
	.equipeFoto4,
	.equipeFoto5,
	.equipeFoto6,
	.equipeFoto7,
	.equipeFoto8 {
		width: 100%;
		left: auto;
		right: auto;
		top: auto;
	}

	.animEquipeTitulo {
		transform: translateY(-50px);
	}

	.animEquipeFoto {
		transform: translateX(-85px);
	}
}

@media (max-width: 520px) {
	.equipeSection {
		padding: 34px 0 42px;
	}

	.equipeContainer {
		width: calc(100% - 24px);
		max-width: 100%;
		height: auto;
	}

	.equipeTitulo {
		font-size: 31px;
		line-height: 0.95;
		margin-bottom: 28px;
	}

	.equipeFotosArea {
		grid-template-columns: repeat(2, 1fr);
		gap: 8px;
	}

	.equipeFoto1,
	.equipeFoto2,
	.equipeFoto3,
	.equipeFoto4,
	.equipeFoto5,
	.equipeFoto6,
	.equipeFoto7,
	.equipeFoto8 {
		width: 100%;
		left: auto;
		right: auto;
		top: auto;
	}
}

@media (max-width: 390px) {
	.equipeTitulo {
		font-size: 28px;
	}

	.equipeFotosArea {
		gap: 7px;
	}
}
`;

export const CssResultado = styled.div`
	width: 100%;
	background: #171d1d;
	font-family: "Barlow", sans-serif;
	overflow: hidden;

	.resultadoSection {
		width: 100%;
		background: #171d1d;
		position: relative;
		overflow: hidden;
		padding: 0;
		box-sizing: border-box;
	}

	.resultadoContainer {
		width: 100%;
		max-width: 1440px;
		height: 1450px;
		margin: 0 auto;
		position: relative;
		overflow: hidden;
		box-sizing: border-box;
	}

	/* ========================= QUADRO ========================= */

	.resultadoQuadroWrap {
		width: 100%;
		max-width: 1440px;
		position: absolute;
		left: 50%;
		top: -8px;
		z-index: 4;
		transform: translateX(-50%);
	}

	.resultadoQuadro {
		width: 100%;
		height: auto;
		display: block;
	}

	/* ========================= TEXTO ========================= */

	.resultadoTextoArea {
		width: 100%;
		max-width: 390px;
		position: absolute;
		left: 11%;
		bottom: 50px;
		z-index: 8;
		color: #fff7df;
	}

	.resultadoTextoArea h2 {
		margin: 0 0 18px;
		color: #fff7df;
		font-size: 40px;
		line-height: 0.86;
		font-weight: 900;
		letter-spacing: -0.025em;
	}

	.resultadoTextoArea h3 {
		margin: 0 0 36px;
		color: #fff7df;
		font-size: 31px;
		line-height: 1;
		font-weight: 800;
		letter-spacing: -0.05em;
	}

	.resultadoTexto {
		width: 100%;
		max-width: 340px;
		color: #fff7df;
		font-size: 20px;
		line-height: 1.28;
		font-weight: 400;
		letter-spacing: -0.035em;
	}

	.resultadoTexto p {
		margin: 0;
	}

	/* ========================= NÚMEROS ========================= */

	.resultadoStat {
		position: absolute;
		z-index: 9;
		color: #fff7df;
		line-height: 1;
	}

	.resultadoStat strong {
		display: block;
		color: #77e7ff;
		font-size: 126px;
		line-height: 0.82;
		font-weight: 900;
		letter-spacing: -0.055em;
	}

	.resultadoStat span {
		display: block;
		margin-top: 10px;
		color: #fff7df;
		font-size: 22px;
		line-height: 1.12;
		font-weight: 400;
		letter-spacing: -0.035em;
	}

	.resultadoStat span strong {
		display: inline;
		color: #fff7df;
		font-size: inherit;
		line-height: inherit;
		font-weight: 800;
		letter-spacing: inherit;
	}

	.resultadoStat15 {
		left: 52%;
		bottom: 260px;
	}

	.resultadoStat20 {
		left: 62%;
		bottom: 90px;
	}

	.resultadoStat20 strong {
		font-size: 132px;
	}

	/* ========================= ANIMAÇÕES ========================= */

	.animResultadoQuadro {
		opacity: 0;
		transform: translateX(-50%) translateY(-80px) scale(0.96);
		filter: blur(4px);
		transition:
			opacity 0.95s ease,
			transform 0.95s ease,
			filter 0.95s ease;
	}

	.animResultadoTexto {
		opacity: 0;
		transform: translateX(-130px);
		transition: opacity 0.85s ease 0.55s, transform 0.85s ease 0.55s;
	}

	.animResultado15 {
		opacity: 0;
		transform: translateX(130px);
		transition: opacity 0.85s ease 0.85s, transform 0.85s ease 0.85s;
	}

	.animResultado20 {
		opacity: 0;
		transform: translateY(120px);
		transition: opacity 0.85s ease 1.1s, transform 0.85s ease 1.1s;
	}

	.animateResultado .animResultadoQuadro {
		opacity: 1;
		transform: translateX(-50%) translateY(0) scale(1);
		filter: blur(0);
	}

	.animateResultado .animResultadoTexto,
	.animateResultado .animResultado15,
	.animateResultado .animResultado20 {
		opacity: 1;
		transform: translate(0, 0);
	}

	/* ========================= RESPONSIVO ========================= */

	@media (max-width: 1366px) {
		.resultadoContainer {
			max-width: 1180px;
			height: 1230px;
		}

		.resultadoQuadroWrap {
			max-width: 1180px;
		}

		.resultadoTextoArea {
			left: 9%;
			bottom: 55px;
		}

		.resultadoTextoArea h2 {
			font-size: 50px;
		}

		.resultadoTextoArea h3 {
			font-size: 28px;
		}

		.resultadoTexto {
			max-width: 315px;
			font-size: 19px;
		}

		.resultadoStat strong {
			font-size: 108px;
		}

		.resultadoStat20 strong {
			font-size: 114px;
		}

		.resultadoStat span {
			font-size: 19px;
		}

		.resultadoStat15 {
			left: 52%;
			bottom: 225px;
		}

		.resultadoStat20 {
			left: 62%;
			bottom: 75px;
		}
	}

	@media (max-width: 1100px) {
		.resultadoContainer {
			height: 1110px;
		}

		.resultadoQuadroWrap {
			width: 1120px;
			max-width: none;
			left: 50%;
			top: -8px;
		}

		.resultadoTextoArea {
			left: 7%;
			bottom: 30px;
			max-width: 330px;
		}

		.resultadoTextoArea h2 {
			font-size: 44px;
		}

		.resultadoTextoArea h3 {
			font-size: 24px;
			margin-bottom: 28px;
		}

		.resultadoTexto {
			max-width: 290px;
			font-size: 17px;
		}

		.resultadoStat strong {
			font-size: 92px;
		}

		.resultadoStat20 strong {
			font-size: 98px;
		}

		.resultadoStat span {
			font-size: 17px;
		}

		.resultadoStat15 {
			left: 52%;
			bottom: 220px;
		}

		.resultadoStat20 {
			left: 62%;
			bottom: 70px;
		}
	}

	@media (max-width: 820px) {
		.resultadoContainer {
			height: 1180px;
		}

		.resultadoQuadroWrap {
			width: 980px;
			left: 50%;
			top: 0;
		}

		.resultadoTextoArea {
			left: 32px;
			bottom: 265px;
			max-width: 90%;
		}

		.resultadoTextoArea h2 {
			font-size: 42px;
		}

		.resultadoTextoArea h3 {
			font-size: 23px;
		}

		.resultadoTexto {
			max-width: 90%;
			font-size: 16px;
		}

		.resultadoStat15 {
			left: 32px;
			bottom: 105px;
		}

		.resultadoStat20 {
			left: 52%;
			bottom: 95px;
		}

		.resultadoStat strong {
			font-size: 76px;
		}

		.resultadoStat20 strong {
			font-size: 84px;
		}

		.resultadoStat span {
			font-size: 15px;
		}

		.animResultadoTexto {
			transform: translateX(-90px);
		}

		.animResultado15 {
			transform: translateX(90px);
		}

		.animResultado20 {
			transform: translateY(90px);
		}
	}

	@media (max-width: 520px) {
		.resultadoContainer {
			height: 1040px;
		}

		.resultadoQuadroWrap {
			width: 760px;
			left: 50%;
			top: 0;
		}

		.resultadoTextoArea {
			left: 22px;
			bottom: 260px;
			max-width: 90%;
		}

		.resultadoTextoArea h2 {
			font-size: 35px;
			margin-bottom: 14px;
		}

		.resultadoTextoArea h3 {
			font-size: 19px;
			margin-bottom: 24px;
		}

		.resultadoTexto {
			max-width: 90%;
			font-size: 14px;
		}

		.resultadoStat strong {
			font-size: 60px;
		}

		.resultadoStat20 strong {
			font-size: 68px;
		}

		.resultadoStat span {
			font-size: 13px;
		}

		.resultadoStat15 {
			left: 22px;
			bottom: 115px;
		}

		.resultadoStat20 {
			left: 52%;
			bottom: 105px;
		}
	}

	@media (max-width: 390px) {
		.resultadoContainer {
			height: 970px;
		}

		.resultadoQuadroWrap {
			width: 680px;
		}

		.resultadoTextoArea {
			left: 18px;
			bottom: 285px;
			max-width: 245px;
		}

		.resultadoTextoArea h2 {
			font-size: 31px;
		}

		.resultadoTextoArea h3 {
			font-size: 17px;
		}

		.resultadoTexto {
			max-width: 220px;
			font-size: 13px;
		}

		.resultadoStat strong {
			font-size: 52px;
		}

		.resultadoStat20 strong {
			font-size: 60px;
		}

		.resultadoStat span {
			font-size: 12px;
		}

		.resultadoStat15 {
			left: 18px;
			bottom: 110px;
		}

		.resultadoStat20 {
			left: 52%;
			bottom: 100px;
		}
	}
`;